import { fetch } from 'src/lib/services/Fetcher'

export const putFetcher = (projectId, token) => {
  return fetch({ method: 'PUT', url: `projects/${projectId}/tokens/${token.id}`, body: token })
}



// WEBPACK FOOTER //
// ./src/tokens/fetchers/putFetcher.js